<template>
  <div>
    <el-form ref="formRef" :model="paramForm" label-width="90px">
      <el-form-item>
        <el-input type="input" v-model="pasteValue" size="medium" style="width:25em;" placeholder="Ctrl+v粘贴" @input="pasteFun"></el-input>
      </el-form-item>
      <el-form-item label="参数名称：">
        <el-input v-model="paramForm.name" placeholder="请输入参数名称" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="参数代码：">
        <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 40}" v-model="paramForm.keycode" placeholder="请输入参数代码" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="参数说明：">
        <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 40}" v-model="paramForm.description" placeholder="请输入参数说明" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="参数配置：">
        <div style="position: relative">
          <el-input id="myInput" type="textarea" :autosize="{ minRows: 6, maxRows: 40}" v-model="paramForm.config" placeholder="请输入参数配置" style="width:25em;" @blur="inputBlur"/>
          <el-popover
              placement="right"
              trigger="click"
              popper-style="width: 300px"
          >
            <template #reference>
              <img class="emoji-btn" src="../../../assets/image/u1f600.png" />
            </template>
            <span v-for="item in emojis" class="emoji-item" :key="item">
              <span v-for="e in item" :key="e.emoji" @click="emojisSelect(e.emoji)">{{e.emoji}}</span>
            </span>
          </el-popover>
        </div>

      </el-form-item>
      <el-form-item>
        <el-button @click.native="cancel" >取消</el-button>
        <el-button type="primary" @click="summit">确定</el-button>
      </el-form-item>
      <div>

      </div>
    </el-form>
<!--    <div class="dialog-footer">-->

<!--    </div>-->
  </div>

</template>

<script>
import { postJson } from "@/api/api"
import { addOrUpdateSysParam } from "@/api/url";
// import utils from "@/assets/emoji/utils"
// import RongEmoji from "@/assets/emoji/RongIMEmoji-2.2.6"
const utils = require('@/assets/emoji/utils')
const RongEmoji = require('@/assets/emoji/RongIMEmoji-2.2.6.js')

export default {
name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
   return {
     paramForm: this.value.paramForm,
     idx: this.value.ids,
     pasteValue: '',
     emojis: '',

     startPos: 0,
     endPos: 0,

   }
  },

  // computed: {
  //   emojis() {
  //     let list = RongEmoji.list;
  //     return utils.sliceArray(list, {size: 23});
  //   }
  // },

  methods: {

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.paramForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '参数名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.paramForm.keycode) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '参数代码不能为空',
          type: 'warning'
        });
        return false
      }
      // if(!this.paramForm.config) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '参数配置不能为空',
      //     type: 'warning'
      //   });
      //   return false
      // }
      let param = {}
      param['id'] = this.idx == -1?0: this.paramForm.id;
      param['name'] = this.paramForm.name;
      param['description'] = this.paramForm.description;
      param['keycode'] = this.paramForm.keycode;
      param['config'] = this.paramForm.config;
      postJson(addOrUpdateSysParam, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    pasteFun () {
      let arr = this.pasteValue.split('&');
      this.paramForm.name = arr[0];
      this.paramForm.keycode = arr[1];
      this.paramForm.description = arr[2];
      this.paramForm.config = arr[3];
    },

    inputBlur(e) {
      let elInput = document.getElementById('myInput')
      this.startPos = elInput.selectionStart
      this.endPos = elInput.selectionEnd
      console.log(this.startPos)
    },

    emojisSelect(emoji) {
      // this.paramForm.config = this.paramForm.config + emoji
      let text = this.paramForm.config
      this.paramForm.config = text.substring(0, this.startPos) + emoji + text.substring(this.endPos)
      this.startPos = this.startPos + 2;
      this.endPos = this.endPos + 2;

    },

  },
  mounted() {
    RongEmoji.init();
    let list = RongEmoji.list;
    this.emojis = utils.sliceArray(list, {size: 23});
  }
}
</script>

<style scoped>
.emoji-btn {
  position: absolute;
  bottom: 12px;
  right: 12px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.emoji-item {
  font-size: 16px;
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
}
</style>
